import { attr, hasMany } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { or } from '@ember/object/computed';
import Super, { BIRTH_DATE_VALIDATOR } from './base-client';
import classic from 'ember-classic-decorator';

const Validations = buildValidations({
  firstName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    messageKey: 'errors.blankField',
  }),
  lastName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    messageKey: 'errors.blankField',
  }),
  emails: validator('has-many'),
  phones: validator('has-many'),
  birthDate: BIRTH_DATE_VALIDATOR,
  state: validator('presence', {
    presence: true,
    messageKey: 'errors.clientContact.stateRequired',
    disabled: or('model.skipContactFormSpecificValidations', 'model.skipPrescreenerV2Validation'),
  }),
});

@classic
export default class ClientContact extends Super.extend(Validations) {
  skipContactFormSpecificValidations = true;

  @hasMany({ async: false }) emails;
  @hasMany({ async: false }) phones;
  @attr() firstName;
  @attr() lastName;
}
